module.exports = __webpack_public_path__ + "static/media/Credit-Card.5ee41818.png";